import {
  AfterContentInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  Output,
  QueryList,
  SimpleChanges
} from '@angular/core';
import { TabsItemComponent } from './tabs-item/tabs-item.component';
import { HorizontalAlignment, Orientation, VerticalAlignment } from '../types';
import { DOCUMENT } from '@angular/common';
import { TabsMode } from './tabs-mode.enum';

@Component({
  selector: 'wfm-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabsComponent implements AfterContentInit, OnChanges {
  @Input() activeTabIndex = 0;
  @Output() activeTabIndexChange = new EventEmitter<number>();

  @Input() tabsMode: TabsMode;

  @ContentChildren(TabsItemComponent) tabs: QueryList<TabsItemComponent>;

  @Input() removableTabs: boolean;

  @Output() closeTabClick = new EventEmitter<number>();

  @Input() orientation: Orientation = Orientation.horizontal;
  @Input() hAlignment: HorizontalAlignment = HorizontalAlignment.left;
  @Input() vAlignment: VerticalAlignment = VerticalAlignment.top;

  @Input() fillSpace = false;

  private window: Window;

  constructor(@Inject(DOCUMENT) private document, private cd: ChangeDetectorRef) {
    this.window = this.document.defaultView;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.activeTabIndex) {
      this.refreshTabs();
    }
  }

  ngAfterContentInit() {
    this.tabs.changes.subscribe(() => this.refreshTabs());
    this.refreshTabs();
  }

  private refreshTabs() {
    this.window.setTimeout(() => {
      this.tabs.forEach((tab, i) => {
        tab.id = i;
        tab.selected = tab.id === this.activeTabIndex;
      });
      this.cd.detectChanges();
    }, 0);
  }

  private closeAttemp = -1;

  selectTab(tab: TabsItemComponent) {
    const tabs = this.tabs.toArray();
    const index = tabs.indexOf(tab);

    if (this.closeAttemp === index) {
      this.closeAttemp = -1;
      return;
    }

    this.activeTabIndex = index;
    tabs.forEach(t => (t.selected = false));
    tabs[index].selected = true;
    this.activeTabIndexChange.emit(index);
  }

  closeTab(tab: TabsItemComponent) {
    const index = this.tabs.toArray().indexOf(tab);
    this.closeAttemp = index;
    this.closeTabClick.emit(index);
  }
}
